export const financingRoundsColumns = [
  { field: "series", headerName: "Series", flex: 1 },
  { field: "date", headerName: "Date", flex: 1,
    sortComparator: (a, b) => {
    const parseDate = (str) => {
      if (!str || str === "—") return 0;
      return new Date(str).getTime();
    };
    return parseDate(a) - parseDate(b);
  },
   },
  { field: "reportingCurrency", headerName: "Reporting Currency", flex: 1 },
  { 
    field: "amountInvested", // Previously mismatching
    headerName: "Amount Invested(Total)", 
    flex: 1,
    align: "right",
    headerAlign: "right"
  },
  { 
    field: "preValuation", // Previously mismatching
    headerName: "Pre-money Valuation", 
    flex: 1,
    align: "right",
    headerAlign: "right"
  },
  { 
    field: "postValuation", // Previously mismatching
    headerName: "Post-money Valuation", 
    flex: 1,
    align: "right",
    headerAlign: "right"
  },
  { field: "leadInvestor", headerName: "Lead Investor", flex: 1.2 },
];